var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFail = function SvgFail(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 110,
    viewBox: "0 0 119 110",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2D422",
    d: "M113.219 109.945H5.045c-3.817 0-6.246-4.09-4.43-7.441L54.7 2.694c1.907-3.519 6.963-3.507 8.861 0 58.653 108.235 54.701 100.379 54.701 102.211 0 2.776-2.247 5.04-5.044 5.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585A60",
    d: "M104.756 102.63H13.509c-2.094 0-3.426-2.244-2.43-4.082l45.623-84.192c1.045-1.93 3.818-1.922 4.86 0l45.624 84.192c1 1.846-.344 4.082-2.43 4.082zM18.15 97.102h81.963L59.132 21.474 18.15 97.102z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#585A60",
    transform: "translate(54.538 48.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.347.164H2.873C1.42.164.243 1.34.243 2.794l.658 19.558c0 1.453 1.177 2.63 2.63 2.63h2.158c1.453 0 2.63-1.178 2.63-2.63l.658-19.558c0-1.453-1.178-2.63-2.63-2.63z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.69,
    cy: 35.251,
    r: 4.542
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fail.3c189d1b.svg";
export { ForwardRef as ReactComponent };